<script lang="ts">
  import { getToday } from "../../functions/src/date";
  import { getMemeOtd } from "../db";
  import Doc from "./Doc.svelte";
  import Footer from "./Footer.svelte";
  import Header from "./Header.svelte";
  import Loader from "./Loader.svelte";
  import Meme from "./Meme.svelte";
  import type { Db } from "../../functions/src/types";

  export let db: Db;

  const today = getToday();
  const memeOtdPromise = getMemeOtd(db, today);

  const mathsBooks = [
    "Pure Year 1",
    "Pure Year 2",
    "Applied Year 1",
    "Applied Year 2",
  ];
  const furtherMathsBooks = [
    "Further Mech",
    "Further Pure Year 1",
    "Further Pure Year 2",
    "Further Stats",
  ];
  const gbdBooklets = [
    "Gravitational Fields",
    "Circular Motion",
    "Electric Fields",
    "Simple Harmonic Motion",
    "Capacitors",
    "Thermal Physics",
    "Magnetism",
    "Nuclear Physics",
    "Radioactivity",
    "Astrophysics",
  ];
</script>

<svelte:head>
  <title>PMP</title>
</svelte:head>
<Header />
<main>
  <section>
    <h2>Maths</h2>
    <div class="book-section">
      {#each mathsBooks as book}
        <Doc name={book} path={`maths/${book}`} />
      {/each}
    </div>
  </section>
  <hr />
  <section>
    <h2>Further Maths</h2>
    <div class="book-section">
      {#each furtherMathsBooks as book}
        <Doc name={book} path={`maths/${book}`} />
      {/each}
    </div>
  </section>
  <hr />
  <section>
    <h2>GBD Booklets</h2>
    <div class="book-section">
      {#each gbdBooklets as booklet}
        <Doc
          name={booklet}
          path={`physics/${booklet.toLowerCase().split(" ").join("_")}_GBD`}
        />
      {/each}
    </div>
  </section>
  <hr />
  <section>
    <h2>Physics</h2>
    <div class="book-section">
      <Doc name="Physics Year 1" path="physics/Physics Year 1" />
      <Doc name="Physics Year 2" path="physics/Physics Year 2" />
      <Doc name="PiP" path="physics/PiP" />
    </div>
  </section>
  <hr />
  <section>
    <h2>Chemistry</h2>
    <div class="book-section">
      <Doc name="Chemistry Year 1" path="chemistry/Chemistry Year 1" />
      <Doc name="Chemistry Year 2" path="chemistry/Chemistry Year 2" />
    </div>
  </section>
  <hr />
  <section id="otd">
    <h2>Meme of the Day</h2>
    {#await memeOtdPromise}
      <Loader />
    {:then memeOtd}
      <Meme url={memeOtd?.url}
        >No meme today :( ... Send suggestions or <a
          class="hover:underline"
          href="schedule">upload one</a
        ></Meme
      >
    {/await}
  </section>
  <hr />
  <section>
    <h2>Meme Archive</h2>
    <p class="epilogue">
      <a class="hover:underline" href="archive">Meme Archive</a>
    </p>
  </section>
</main>
<Footer />
